import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useUserData } from "@/components/navigation/hooks/useUserData";
import { needsOnboarding } from "@/utils/onboarding";

export const CheckOnboardingState = () => {
    const router = useRouter();
    const location = usePathname();
    const pathArray = location.split('/');
    const page = pathArray[pathArray.length - 2];
    const pageId = pathArray.length > 1 ? pathArray[pathArray.length - 1] : '';

    const [mounted, setMounted] = useState(false);
    const { 
        userDetails, 
        isUserDetailsLoading, 
        team, 
        teamPreferences, 
        isLoadingTeamPreferences,
        effectiveProducts,
        effectiveBuyingPersona 
    } = useUserData();

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (mounted && !isUserDetailsLoading && !isLoadingTeamPreferences && userDetails) {
            const onboardingData = {
                userDetails,
                team,
                teamPreferences: teamPreferences ?? null,
                effectiveProducts,
                effectiveBuyingPersona
            };

            if (needsOnboarding(onboardingData)) {
                router.push('/onboarding');
            }
        }
    }, [mounted, isUserDetailsLoading, isLoadingTeamPreferences, userDetails, team, teamPreferences, effectiveProducts, effectiveBuyingPersona, router]);

    return null;
}